import { createPortal } from 'react-dom';

interface ItemTicket {
  nombre?: string;
  producto_nombre?: string;
  cantidad: number;
  precio: number;
  total?: number;
}

interface TicketImprimibleProps {
  venta: {
    numero: string;
    fecha: string;
    cliente_nombre: string;
    placa_bus?: string | null;
    tipo_pago: string;
    subtotal: number;
    igv: number;
    descuento?: number;
    total: number;
    estado?: string;
    items: ItemTicket[];
  };
}

const TicketImprimible = ({ venta }: TicketImprimibleProps) => {
  return createPortal(
    <div className="ticket-print-only">
      <p className="centro bold titulo">SISTEMA MANTSILA</p>
      <p className="centro">Venta de Repuestos</p>
      <hr />
      <p><span className="bold">Venta #:</span> {venta.numero}</p>
      <p><span className="bold">Fecha:</span> {new Date(venta.fecha).toLocaleString('es-PE')}</p>
      <p><span className="bold">Cliente:</span> {venta.cliente_nombre}</p>
      {venta.placa_bus && <p><span className="bold">Bus/Padrón:</span> {venta.placa_bus}</p>}
      <p><span className="bold">Tipo Pago:</span> {venta.tipo_pago.toUpperCase()}</p>
      <hr />
      <p className="bold">PRODUCTOS</p>
      {venta.items.map((item, i) => (
        <div className="fila" key={i}>
          <span>{item.cantidad}x {item.nombre || item.producto_nombre}</span>
          <span>S/ {(item.total ?? item.precio * item.cantidad).toFixed(2)}</span>
        </div>
      ))}
      <hr />
      <div className="fila"><span>Subtotal:</span><span>S/ {venta.subtotal.toFixed(2)}</span></div>
      {!!venta.descuento && venta.descuento > 0 && (
        <div className="fila"><span>Descuento:</span><span>-S/ {venta.descuento.toFixed(2)}</span></div>
      )}
      <div className="fila bold total"><span>TOTAL:</span><span>S/ {venta.total.toFixed(2)}</span></div>
      <hr />
      <p className="centro">Estado: {(venta.estado || 'PAGADO').toUpperCase()}</p>
      <p className="centro" style={{ marginTop: '4mm' }}>¡Gracias por su compra!</p>
      <p className="centro" style={{ marginTop: '2mm', fontSize: '2mm' }}>SOFTWARE DISEÑADO POR TU LUGAR INTELIGENTE 931398916</p>
    </div>,
    document.body
  );
};

export default TicketImprimible;
